import React from "react";

let Employee = React.createClass({

    propTypes: {
        name: React.PropTypes.string.isRequired,
        imgUrl: React.PropTypes.string.isRequired,
        bwUrl: React.PropTypes.string.isRequired,
        team: React.PropTypes.string,
        networks: React.PropTypes.object,

    },
    render() {
        return (
            <div className="eo-employee">
                <img src={this.props.bwUrl} className={["eo-people-grid-person-img img-bw"].join(" ")}/>
                <img src={this.props.imgUrl} className={["eo-people-grid-person-img"].join(" ")}/>
                <div className="eo-people-grid-person-content-wrap">
                    <div className="eo-people-grid-person-content">
                        <div className="items">
                            <p className="person-name">{this.props.name}</p>
                            <p className="person-title">{this.props.team}</p>
                            <ul className="person-networks">
                                {
                                    this.props.networks.map((network, i) => {
                                        return (
                                            <li className="person-network" key={i}>
                                                <a className={["icon network-icon", network.icon].join(" ")} href={network.url} target="_blank"/>
                                            </li>
                                        );
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default Employee;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/our-story/components/Employee.js
 **/